import React from "react";
import caselogo from "../../assets/images/caselogo.png";
import Menu from "../../assets/images/menu.svg";
import LogoPw from "../../assets/images/Logo.png";
import I9form from "../legalforms/I9form";

function RedirectI9Form() {
  return (
    <div className="container-fluid" id="main">
      <div className="fixHeader candPrv">
        <div className="row">
          <div className="col-lg-2 col-md-3 sideCont">
            <div className="hd-left">
              <img
                src={Menu}
                alt="test"
                className="preview-bck-icon"
                onClick={() => {}}
              />
            </div>
          </div>
          <div className="w-100 logo-sec">
            <div className="logoCent logo-sec">
              <img src={caselogo} alt="logo" className="logo-inner mb-0 me-2" />
            </div>
            <div className="logoSide logo-sec">
              <img src={LogoPw} alt="copy" className="logo-inner mb-0 me-2" />
            </div>
          </div>
        </div>
      </div>

      <div className="row px-4 topSpce_view">
        {/* <I9form
          review={isReview}
          data={isNewI9Form === true ? i9Data : data}
          companyName={companyName}
          companyAddress={companyAddress}
          verifyStatus={everifyStatus}
          fetchSections={fetchSections}
          unconfirmedData={unconfirmedData}
          photMatchImage={photMatchImage}
          resetForm={resetForm}
          isNewI9Form={true}
          redirectToEverify={redirectToEverify}
        /> */}
      </div>
    </div>
  );
}

export default RedirectI9Form;
